import React, { Component } from 'react';

class SearchBar extends Component{
    state = {term: ''};

    onFormSubmit = (event)=>{
        event.preventDefault();
        this.props.onFormSubmit(this.state.term);
    };

    render(){
        return(
            <form onSubmit={this.onFormSubmit}>
            <div className="search-bar">
                <i className="search icon"></i>
                <input type="text"
                       placeholder="Search Courses"  
                       onChange={(e)=>{
                           this.setState({term: e.target.value})}}
                />
            </div>
            </form>
        )

    }
}

export default SearchBar;